module.exports = __webpack_public_path__ + "img/reset_floodlight_step_3.e0fcf664.png";